import React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button
} from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import currencyLocalMessages from './messages/LocaleCurrencyMessages';
import homePageV2Messages from '../landingPage_v2/assets/messages/homePageMessages';
import physicalCardDetailMessages from '../giftCardDetailsPage_v2/messages/physicalCardDetailMessages';
import { selectedCardType } from '../landingPage/landingPageModule';
import { CARD_TYPES } from '../constants/constants';

const SiteSwitchDialog = ({
    intl, isOpen, handleCloseModel, currencyName,
    physicalCard, language, supportedLocale, currency,
    isPhysicalcartMaxlimitReached, onConfirmCTA, cartMaxNumPlasticCards, saveSelectedCardType
}) => {
    const dialogTitleText = physicalCard
        ? intl.formatMessage(currencyLocalMessages.physicalCardText) : currency || language || '';

    const handleClose = () => {
        handleCloseModel(false);
    };

    const handleContinue = () => {
        if (isPhysicalcartMaxlimitReached) {
            saveSelectedCardType(CARD_TYPES.Digital, true);
            onConfirmCTA();
            handleClose();
            return;
        }
        const currentUrl = new URL(window.location.href);
        const oldPath = '/store';
        const newUrl = `${currentUrl.origin}${oldPath}?locale=${supportedLocale}`;
        window.open(newUrl, '_blank');
        handleClose();
    };

    let message = '';

    if (physicalCard && !isPhysicalcartMaxlimitReached) {
        message = intl.formatMessage(currencyLocalMessages.physicalCardTypographyText);
    } else if (currencyName && currency) {
        message = intl.formatMessage(currencyLocalMessages.currencyTypographyText, { currencyName, currency });
    } else if (language) {
        message = intl.formatMessage(currencyLocalMessages.languageTypographyText, { language });
    } else if (isPhysicalcartMaxlimitReached) {
        message = intl.formatMessage(physicalCardDetailMessages.physicalCardLimitSubHeading,
            { cartMaxNumPlasticCards });
    }

    return (
        <Dialog
            fullWidth
            maxWidth='sm'
            open={isOpen}
            onClose={handleClose}
            className='switch-sites-dialog'
        >
            <DialogTitle className='switch-sties-title'>
                {isPhysicalcartMaxlimitReached
                    ? intl.formatMessage(physicalCardDetailMessages.physicalCardLimit)
                    : intl.formatMessage(currencyLocalMessages.dialogTitleText, { dialogTitleText })}
            </DialogTitle>
            <DialogContent className='switch-sties-content'>
                <Typography className='switch-sties-content-text' variant='caption'>
                    {message}
                </Typography>
            </DialogContent>
            <DialogActions className='switch-sties-actions'>
                <Button
                    className='switch-sties-cancel-button'
                    variant='text'
                    onClick={handleClose}
                >
                    {intl.formatMessage(currencyLocalMessages.cancelButtonText)}
                </Button>
                <Button
                    className='switch-sties-continue-button'
                    onClick={handleContinue}
                    variant='contained'
                >
                    { isPhysicalcartMaxlimitReached
                        ? intl.formatMessage(homePageV2Messages.digitalGiftCardCTAButtonText)
                        : intl.formatMessage(currencyLocalMessages.continueButtonText)}
                    {!isPhysicalcartMaxlimitReached && <OpenInNewIcon fontSize='small' titleAccess="- opens in a new window" /> }
                </Button>
            </DialogActions>
        </Dialog>
    );
};

SiteSwitchDialog.defaultProps = {
    currencyName: '',
    physicalCard: false,
    language: '',
    supportedLocale: 'en-us',
    currency: '',
    isPhysicalcartMaxlimitReached: false,
    onConfirmCTA: () => {},
    cartMaxNumPlasticCards: 0
};

SiteSwitchDialog.propTypes = {
    
    intl: intlShape.isRequired,
    isOpen: PropTypes.bool.isRequired,
    handleCloseModel: PropTypes.func.isRequired,
    currencyName: PropTypes.string,
    physicalCard: PropTypes.bool,
    language: PropTypes.string,
    supportedLocale: PropTypes.string,
    currency: PropTypes.string,
    isPhysicalcartMaxlimitReached: PropTypes.bool,
    onConfirmCTA: PropTypes.func,
    cartMaxNumPlasticCards: PropTypes.number,
    saveSelectedCardType: PropTypes.func.isRequired
};

const mapDispatchToProps = {
    saveSelectedCardType: selectedCardType

};

export default connect(null, mapDispatchToProps)(injectIntl(SiteSwitchDialog));
